<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zmIMVO/tc-custom/9781497685567.jpg?1737196543303" alt="This image is the cover for the book Battle Mask, The Executioner"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Battle Mask, The Executioner
      </h1>
      <p class="bookDescription body article font2">
        <b>The Executioner, a lone-wolf vigilante “who would make Jack Reacher think twice,” takes his war on the mob to a new level (Empireonline.com).</b><br/>  <br/> Once a Vietnam military hero, crack sniper Mack Bolan is now a vigilante, driven by the death of his Massachusetts family to exact vengeance on the mob. Waging war on the West Coast, the Executioner amassed a ten-man army as backup. Seven are now dead. Two are in jail. Only Bolan remains. With a bounty on his head, and every cop in Los Angeles on his tail, Bolan decides to erase his greatest liability: his face.<br/>  <br/> Under the knife of a former army surgeon, Bolan is transformed. With trademark cunning, he infiltrates the Sicilian syndicate that butchered his friends. In cozying up to the boss’s daughter, Bolan’s plan of revenge has never been so intimate. The Executioner may have a new look, but he’s got the same attitude. Soon his fury is going explode, and strike terror in the very heart of the Mafiosi.<br/>  <br/> In writing his iconic Executioner series, Don Pendleton turned his lone-wolf vigilante into a bestselling phenomenon and “spawned a genre” that still influences artists today (<i>The New York Times</i>). Gerry Conway, cocreator of the Marvel Comics avenger, <i>The Punisher</i>, cited the novels as “my inspiration . . . [the] modern equivalent of the pulps.” More than two hundred million copies of the Executioner books have been sold—and a major motion picture based on this classic action series is now in development.<br/><br/> Battle Mask <i>is the 3rd book in the Executioner series, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don Pendleton
      </h2>
      
      <p class="authorDescription body article">Don Pendleton (1927&ndash;1995) was born in Little Rock, Arkansas. He served in the US Navy during World War II and the Korean War. His first short story was published in 1957, but it was not until 1967, at the age of forty, that he left his career as an aerospace engineer and turned to writing full time.&#160;After producing a number of science fiction and mystery novels, in 1969 Pendleton launched his first book in the Executioner saga:&#160;<I>War Against the Mafia</I>.&#160;The series, starring Vietnam veteran Mack Bolan, was so successful that it inspired a new American literary genre, and Pendleton became known as the father of action-adventure.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?774a7204